import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getTiposDeCuentasContables } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const TiposDeCuentasContables = ({ permission }) => (
  <PlainCRUD
    title="Tipos de Cuentas Contables"
    permission={permission}
    get={getTiposDeCuentasContables}
    fields={[defaultFields.clave, defaultFields.descripcion]}
    readOnly
  />
);

export default TiposDeCuentasContables;
